// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__mXi17","inner":"Footer_inner__LxF35"};